import { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { HeroSection } from '../components/home/HeroSection';
import { ApproachSection } from '../components/home/ApproachSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { StatsSection } from '../components/home/StatsSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { CTASection } from '../components/home/CTASection';
import { FAQSection } from '../components/home/FAQSection';
import { ContactSection } from '../components/home/ContactSection';

export const HomePage = () => {
  useEffect(() => {
    // Scroll to hash on page load
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <main id="main-content" tabIndex={-1} data-testid="home-page">
      <SEO
        description="Boutique event production company in Pretoria. Entertainment, technical production, LED screens, live streaming, effects, catering and décor — one team."
        path="/"
      />
      <HeroSection />
      <ApproachSection />
      <ServicesSection />
      <StatsSection />
      <TestimonialsSection />
      <CTASection />
      <FAQSection />
      <ContactSection />
    </main>
  );
};

export default HomePage;
